import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import { useNavigate, useSearchParams } from 'react-router-dom';
import Notification from "../../Notification";



const CreateWhatsappCredential = () => {
    const [searchParams] = useSearchParams();
    console.log("business_name", searchParams.get('business_name'), "business_id", searchParams.get('business_name'));
    const [notify, setNotify] = useState({ isOpen: false, messsage: '', type: '' })
    const [businessName, setBusinessName] = useState();
    const [businessId, setBusinessId] = useState();
    const [service, setService] = useState();
    // const [phoneNumber,setPhoneNumber] = useState();
    const [phoneNumberId, setPhoneNumberId] = useState();
    const [appType, setAppType] = useState();
    const [appId, setAppId] = useState();
    const [wabaId, setWabaId] = useState();
    const [accessToken, setAccessToken] = useState();


    const getWhatsappCredential = () => {
        Axios.get(`api/business/get-whatsapp-credential?business_id=${searchParams.get('business_id')}`)
            .then((resp) => {
                console.log(resp.data.data.length);
                setBusinessName(searchParams.get('business_name'));
                setBusinessId(searchParams.get('business_id'));
                setService("whatsapp");
                setAppType("Business");
                if (resp.data.data.length !== 0) {
                    setPhoneNumberId(resp.data.data[0].phone_number_id);
                    setAppId(resp.data.data[0].app_id);
                    setWabaId(resp.data.data[0].waba_id);
                    setAccessToken(resp.data.data[0].access_token);
                }
            })
            .catch((e) => {
                console.log(e);
            })
    }



    useEffect(() => {
        getWhatsappCredential();
    }, [])

    const submitCredential = () => {
        console.log(businessName, businessId, service, phoneNumberId, appType, appId, wabaId, accessToken);
        Axios
            .post("api/business/insert-business-whatsapp-credential", {
                business_name: businessName,
                business_id: businessId,
                service: service,
                // mobile_no:phoneNumber,
                phone_number_id: phoneNumberId,
                app_type: appType,
                app_id: appId,
                waba_id: wabaId,
                access_token: accessToken
            })
            .then((response) => {
                console.log("this", response);
                setNotify({
                    isOpen: true,
                    messsage: response.data.message,
                    type: 'success'
                })
            }).catch((error) => {
                setNotify({
                    isOpen: true,
                    messsage: "Something Went Wrong",
                    type: 'error'
                })
            });

    }

    return (
        <>

            <div className="content-page">
                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">
                                    <h4 className="page-title">Create Whatsapp Credential</h4>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="card-box" style={{ width: "50%", marginTop: "10px" }}>

                                <div className="form-group mb-3">
                                    <label htmlFor="businessName">Business Name</label>
                                    <input
                                        onChange={(e) => setBusinessName(e.target.value)}
                                        type="text"
                                        id="businessName"
                                        value={businessName}
                                        className="form-control"
                                        placeholder="Enter Business Name"
                                        disabled
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="businessId">Business Id</label>
                                    <input
                                        onChange={(e) => setBusinessId(e.target.value)}
                                        type="text"
                                        id="businessId"
                                        value={businessId}
                                        className="form-control"
                                        placeholder="Enter Business Id"
                                        disabled
                                    />
                                </div>


                                <div className="form-group mb-3">
                                    <label htmlFor="service">Service</label>
                                    <input
                                        onChange={(e) => setService(e.target.value)}
                                        type="text"
                                        id="service"
                                        value={service}
                                        className="form-control"
                                        placeholder="Enter Service Name"
                                        disabled
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="appType">App Type</label>
                                    <input
                                        onChange={(e) => setAppType(e.target.value)}
                                        type="text"
                                        id="appType"
                                        value={appType}
                                        className="form-control"
                                        placeholder="Enter Service Name"
                                        disabled
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <label htmlFor="appId">App Id</label>
                                    <input
                                        onChange={(e) => setAppId(e.target.value)}
                                        type="text"
                                        id="appId"
                                        value={appId}
                                        className="form-control"
                                        placeholder="Enter App Id"
                                    />
                                </div>


                                {/* <div className="form-group mb-3">
                                    <label htmlFor="phoneNumber">Phone Number</label>
                                    <input
                                        onChange={(e) => setPhoneNumber(e.target.value)}
                                        id="phoneNumber"
                                        value={phoneNumber}
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Phone Number"
                                    />
                                </div> */}

                                <div className="form-group mb-3">
                                    <label htmlFor="phoneNumberId">Phone Number Id</label>
                                    <input
                                        onChange={(e) => setPhoneNumberId(e.target.value)}
                                        type="text"
                                        id="phoneNumberId"
                                        value={phoneNumberId}
                                        className="form-control"
                                        placeholder="Enter Phone Number Id"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="wabaId">Whatsapp Business Account Id</label>
                                    <input
                                        onChange={(e) => setWabaId(e.target.value)}
                                        type="text"
                                        id="wabaId"
                                        value={wabaId}
                                        className="form-control"
                                        placeholder="Enter waba Id"
                                    />
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="accessToken">Access Token</label>
                                    <textarea
                                        onChange={(e) => setAccessToken(e.target.value)}
                                        id="accessToken"
                                        value={accessToken}
                                        className="form-control"
                                        placeholder="Enter Access Token"
                                        style={{ minHeight: "110px" }}
                                    />
                                </div>
                                <button onClick={submitCredential} className="btn btn-gradient btn-block" type="submit"> Submit </button>
                                {
                                    notify.isOpen ?
                                        <Notification
                                            notify={notify}
                                            setNotify={setNotify} />
                                        : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CreateWhatsappCredential;